import { render, staticRenderFns } from "./w-menu-item.vue?vue&type=template&id=98b6247c&lang=pug&"
import script from "./w-menu-item.vue?vue&type=script&lang=js&"
export * from "./w-menu-item.vue?vue&type=script&lang=js&"
import style0 from "./w-menu-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98b6247c')) {
      api.createRecord('98b6247c', component.options)
    } else {
      api.reload('98b6247c', component.options)
    }
    module.hot.accept("./w-menu-item.vue?vue&type=template&id=98b6247c&lang=pug&", function () {
      api.rerender('98b6247c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-menu-item.vue"
export default component.exports